import { ActionProps, StoreProps } from "../store";
export function reducer(state: StoreProps, action: ActionProps) {
  switch (action.type) {
  }
}
